import { Gray70, typeCompact14MediumProperties } from '@traceair/tds';
import { stylesheet } from 'typestyle';
import { GcpIcon } from '../../../../../images/components/GcpIcon';
import { MissionWindowGcpGuides } from '../projectInfo/MissionWindowGcpGuides';

const css = stylesheet({
  container: {
    display: 'flex',
    marginBottom: 24,
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    ...typeCompact14MediumProperties,
  },
  icon: {
    margin: -3,
  },
});

export const GcpRequestUploadHeader = () => {
  return (
    <header className={css.container}>
      <div className={css.title}>
        <GcpIcon fill={Gray70} width={30} height={30} className={css.icon} />
        GCPs
      </div>

      <div>
        <MissionWindowGcpGuides />
      </div>
    </header>
  );
};
